import React, { useState } from "react";
import GenericPopup from "@Components/Popup/Popup";
import NoteAddRoundedIcon from "@mui/icons-material/NoteAddRounded";
import Joi from "joi";
import {
  OptionalDropDownValidation,
  pastOrNowDateValidation,
} from "@Utils/Validations/UserValidations/UserValidationFieldsSchema";
import DropDown from "@Components/DropDown/DropDown";
import { validateForm } from "@Utils/Validations/HelperFunctions/FormValidationFunctions";
import {
  paymentTypes,
  Currency,
} from "../../Utils/HelpingObjects/HelpingObjects";
import { Grid, Typography, TextField } from "@mui/material";
import DateSelector from "@Components/DateTimePickers/DatePicker";
export const AddPaymentPopup = (
  invoiceId,
  showPopup,
  closePopup,
  Confirm,
  loading
) => {
  const emptyPayment = {
    paymentName: "",
    paymentType: "Select Payment Type",
    amount: "",
    currency: "Select Currency",
    date: null,
  };
  const [payment, setPayment] = useState(emptyPayment);

  const validationSchema = Joi.object({
    paymentName: Joi.string().required(),
    paymentType: OptionalDropDownValidation("Payment Type"),
    amount: Joi.number().required().messages({
      "number.empty": "Amount is required",
      "any.required": "Amount is required",
      "number.base": "Amount must be a number",
    }),
    currency: OptionalDropDownValidation("Currency"),
    date: pastOrNowDateValidation,
    invoiceId: Joi.number().required(),
  });

  const [errors, setErrors] = useState({
    paymentName: "",
    paymentType: "",
    amount: "",
    currency: "",
    date: "",
  });

  const onDatePick = (newValue) => {
    setPayment({ ...payment, date: newValue });
    setErrors({ ...errors, date: "" });
  };
  const onCancel = () => {
    setPayment({ ...emptyPayment });
    closePopup();
    setErrors({
      paymentName: "",
      paymentType: "",
      amount: "",
      currency: "",
      date: "",
    });
  };

  const content = (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="body1" sx={{ mb: 1 }}>
          Payment Name
        </Typography>
        <TextField
          fullWidth
          placeholder="Payment Name"
          value={payment.paymentName}
          onChange={(e) => {
            const value = e.target.value;
            setPayment({ ...payment, paymentName: value });
            setErrors({ ...errors, paymentName: "" }); // Clear error message on input
          }}
          error={!!errors.paymentName}
          helperText={
            <Typography variant="body2" marginTop={1} color={"error"}>
              {errors.paymentName || ""}
            </Typography>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" sx={{ mb: 1 }}>
          Payment Type
        </Typography>
        <DropDown
          state={payment.paymentType}
          setState={(value) => {
            setPayment({ ...payment, paymentType: value });
            setErrors({ ...errors, paymentType: "" }); // Clear error message on selection
          }}
          name="payment Type"
          label=""
          items={paymentTypes}
          placeholder="Select Payment Type"
          helperText={errors.paymentType}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" sx={{ mb: 1 }}>
          Currency
        </Typography>
        <DropDown
          state={payment.currency}
          setState={(value) => {
            setPayment({ ...payment, currency: value });
            setErrors({ ...errors, currency: "" }); // Clear error message on selection
          }}
          name="currency"
          label=""
          items={Currency}
          placeholder="Select Currency"
          helperText={errors.currency}
        />
      </Grid>
      <Grid item xs={12}>
        <DateSelector
          name={"Payment Date"}
          value={payment.date}
          error={errors.date}
          onPick={onDatePick}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" sx={{ mb: 1 }} align="left">
          Amount
        </Typography>
        <TextField
          fullWidth
          placeholder="Amount"
          value={payment.amount}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d*\.?\d*$/.test(value)) {
              setPayment({ ...payment, amount: value });
              setErrors({ ...errors, amount: "" }); // Clear error message on input
            }
          }}
          type="number"
          inputProps={{ min: 0, step: "0.01" }}
          error={!!errors.amount}
          helperText={
            <Typography variant="body2" marginTop={1} color={"error"}>
              {errors.amount || ""}
            </Typography>
          }
        />
      </Grid>
    </Grid>
  );

  const submit = () => {
    const formattedPayment = {
      ...payment,
      date: payment.date
        ? typeof payment.date.toDate === "function"
          ? payment.date.toDate()
          : payment.date instanceof Date
          ? payment.date
          : new Date(payment.date)
        : null,
      invoiceId: invoiceId,
    };

    if (validateForm(formattedPayment, setErrors, validationSchema)) {
      Confirm(formattedPayment);
      window.location.reload();
      setPayment({ ...emptyPayment });
      setErrors({
        paymentName: "",
        paymentType: "",
        amount: "",
        currency: "",
        date: "",
      });
    }
  };

  return (
    <GenericPopup
      icon={<NoteAddRoundedIcon color="white" fontSize="large" />}
      open={showPopup}
      title={"Add Payment"}
      content={content}
      buttons={[
        {
          text: "Cancel",
          onClick: onCancel,
          color: "secondary",
          variant: "outlined",
        },
        {
          text: "Add",
          onClick: submit,
          color: "primary",
          variant: "contained",
          loading: loading,
        },
      ]}
    />
  );
};
